export const CANCELLED_DC_COLUMNS = [
  {
    header: 'DC No',
    accessorKey: 'delivery_challan_no',
    size: 120,
  },
  {
    header: 'Date',
    accessorKey: 'delivery_challan_date',
    size: 110,
  },
  {
    header: 'Plant',
    accessorKey: 'plant',
    size: 140,
  },
  {
    header: 'Customer',
    accessorKey: 'customer_name',
    size: 160,
  },
  {
    header: 'Site',
    accessorKey: 'project_name',
    size: 160,
  },
  {
    header: 'Grade',
    accessorKey: 'grade',
    size: 100,
  },
  {
    header: 'DC Qty',
    accessorKey: 'dc_qty',
    size: 90,
  },
  {
    header: 'Vehicle',
    accessorKey: 'vehicle_no',
    size: 120,
  },
];

export function mapCancelledDcRow(dc) {
  const salesOrder = dc.work_schedule?.sales_order_detail?.sales_order;
  return {
    id: dc.id,
    delivery_challan_no: [dc.prefix, dc.delivery_challan_no].filter(Boolean).join('') || String(dc.delivery_challan_no || ''),
    delivery_challan_date: dc.delivery_challan_date || '',
    plant: dc.work_schedule?.plant?.alias_name || dc.work_schedule?.plant?.name || '',
    customer_name: salesOrder?.consignee?.customer?.name || '',
    project_name: salesOrder?.consignee?.project_name || '',
    grade: dc.work_schedule?.sales_order_detail?.product?.name || '',
    dc_qty: Number(dc.dc_qty || 0).toFixed(2),
    vehicle_no: dc.vehicle?.name || dc.customer_vehicle_no || '',
  };
}
